import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.regexp.replace";
import _defineProperty from "D:/Project/heshan/code/heshan_web/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
import { mapGetters } from "vuex";
import NProgress from "nprogress"; // progress bar

import "nprogress/nprogress.css"; // progress bar style

export default {
  name: "AvueIframe",
  data: function data() {
    return {
      urlPath: this.getUrlPath() //iframe src 路径

    };
  },
  created: function created() {
    NProgress.configure({
      showSpinner: false
    });
  },
  mounted: function mounted() {
    this.load();
    this.resize();
  },
  props: ["routerPath"],
  watch: {
    $route: function $route() {
      this.load();
    },
    routerPath: function routerPath() {
      // 监听routerPath变化，改变src路径
      this.urlPath = this.getUrlPath();
    }
  },
  computed: _objectSpread(_objectSpread({}, mapGetters(["screen"])), {}, {
    src: function src() {
      return this.$route.query.src ? this.$route.query.src.replace("$", "#") : this.urlPath;
    }
  }),
  methods: {
    // 显示等待框
    show: function show() {
      NProgress.start();
    },
    // 隐藏等待狂
    hide: function hide() {
      NProgress.done();
    },
    // 加载浏览器窗口变化自适应
    resize: function resize() {
      var _this = this;

      window.onresize = function () {
        _this.iframeInit();
      };
    },
    // 加载组件
    load: function load() {
      var _this2 = this;

      this.show();
      var flag = true; //URL是否包含问号

      if (this.$route.query.src !== undefined && this.$route.query.src.indexOf("?") === -1) {
        flag = false;
      }

      var list = [];

      for (var key in this.$route.query) {
        if (key !== "src" && key !== "name" && key !== "i18n") {
          list.push("".concat(key, "= this.$route.query[key]"));
        }
      }

      list = list.join("&").toString();

      if (flag) {
        this.$route.query.src = "".concat(this.$route.query.src).concat(list.length > 0 ? "&list" : "");
      } else {
        this.$route.query.src = "".concat(this.$route.query.src).concat(list.length > 0 ? "?list" : "");
      } //超时3s自动隐藏等待狂，加强用户体验


      var time = 3;
      var timeFunc = setInterval(function () {
        time--;

        if (time === 0) {
          _this2.hide();

          clearInterval(timeFunc);
        }
      }, 1000);
      this.iframeInit();
    },
    //iframe窗口初始化
    iframeInit: function iframeInit() {
      var _this3 = this;

      var iframe = this.$refs.iframe;
      var clientHeight = document.documentElement.clientHeight - (screen > 1 ? 200 : 130);
      if (!iframe) return;
      iframe.style.height = "".concat(clientHeight, "px");

      if (iframe.attachEvent) {
        iframe.attachEvent("onload", function () {
          _this3.hide();
        });
      } else {
        iframe.onload = function () {
          _this3.hide();
        };
      }
    },
    getUrlPath: function getUrlPath() {
      //获取 iframe src 路径
      var url = window.location.href;
      url = url.replace("/myiframe", "");
      return url;
    }
  }
};